import { useQuery } from '@tanstack/react-query';

import { API } from 'src/reactQuery/Api';
import { QUERY_KEYS } from 'src/reactQuery/QueryKeys';
import {
  getRequest,
  paginationMapper,
  resolveQueryString,
} from 'src/utils/request';

import { RequestDataArray } from 'src/types/requestData';

const mapCandidateShifts = (
  attributes: UCM.CandidateShiftsRawType,
  id: string,
): UCM.CandidateShiftsType => {
  return {
    id,
    uuid: attributes.uuid,
    shiftStartsAt: attributes.shift_starts_at,
    shiftEndsAt: attributes.shift_ends_at,
    createdAt: attributes.created_at,
    updatedAt: attributes.updated_at,
    job: {
      id: attributes.job.id,
      uuid: attributes.job.uuid,
      title: attributes.job.title,
      type: attributes.job.type,
    },
    project: {
      id: attributes.project.id,
      uuid: attributes.project.uuid,
      name: attributes.project.name,
    },
    userJobRating: attributes.user_job_rating,
  };
};

const getCandidateShifts = async (
  uuid: string,
  params: Record<string, string | number>,
) => {
  const query = resolveQueryString([], params);

  const {
    data: { data, meta },
  } = await getRequest<
    RequestDataArray<UCM.CandidateShiftsRawType, UCM.MetaRawType>
  >(API.GET.getCandidateDetailsJobShifts(uuid, query));

  return {
    data: data.map(({ attributes, id }) => mapCandidateShifts(attributes, id)),
    meta: paginationMapper(meta),
  };
};

export const useGetCandidateShifts = ({
  uuid,
  params,
  enabled = false,
}: {
  uuid: string;
  params: Record<string, string | number>;
  enabled?: boolean;
}) => {
  return useQuery({
    queryKey: [QUERY_KEYS.CANDIDATE_SHIFTS, uuid, params],
    queryFn: () => getCandidateShifts(uuid, params),
    enabled,
  });
};
